export default __webpack_public_path__ + "static/petsafe-logo-v2-3fc2ead72232b2ae17cd539528bf0d7a.svg";